import React from "react";
import Link from "next/link";
import {makeStyles} from 'tss-react/mui';

// @mui/icons-material
// core components
import Button from "../components/CustomButtons/Button.js";
import Card from "../components/Card/Card.js";

import styles from "../styles/jss/nextjs-material-kit/pages/landingPageSections/jobAndCoursesSideBarStyle.js";
import {useJobsListRequest} from "../request/api";
import {buildSlug} from "../util/url";
import JobCard from "../components/JobCard/JobCard";
import Grid from "@mui/material/Grid";
import Image from "next/image";

const useStyles = makeStyles()(styles);

export default function JobsSidebar({
                                      headingText = 'Latest jobs',
                                      careerZones,
                                      org,
                                      excludeId = undefined,
                                      isUniversity = false
                                    }) {
  const {classes, cx} = useStyles();

  const {data, error, isLoading} = useJobsListRequest({
    career_zone_ids: careerZones || [],
    employer_id: org ? org.id : null,
    limit: 5,
  });

  const jobs = data?.jobs.filter(job => job.id !== excludeId) || [];

  const noJobs = isUniversity ? null :(
    <Card
      style={{paddingBottom: 0}}
      className={cx(
        classes.jobSection,
        classes.jobCard,
        classes.cardFooter,
      )}
    >
      <p>None right now.</p>

      <Button
        style={{boxShadow: "none"}}
        className={cx(classes.primaryColor, classes.seeMoreBtn)}
        color="info"
        component={Link}
        href="/jobs"
        size="sm"
      >
        See all
      </Button>
    </Card>
  );

  return (
    <div className={[classes.section, "aassaaasasa"].join(" ")}>
      <div className={cx(classes.container, "sidebar")}>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} style={{paddingLeft: 0}}>
            <h4
              className={cx(classes.title, classes.customHeading, headingText.length > 20 ? classes.smallerHeading : undefined)}
            >
              {headingText}
            </h4>
          </Grid>
          <Grid item
                className={cx(classes.paddingZero)}
                xs={12}
                sm={12}
                md={12}
          >
            <Card
              style={{paddingBottom: 0}}
              className={cx(
                classes.jobCard,
                classes.lightGreen,
              )}
            >
              {org && <div className={classes.logoContainer}>
                <img
                  src={org.logo_uri}
                  alt={`${org.name} logo`}
                />
              </div>}
              {jobs.length ? jobs.map((job) => (
                <Link key={`job-${job.id}`}
                      href={`/${buildSlug(job.type)}/${buildSlug(job.organisation.name)}/${buildSlug(job.jobType)}/${buildSlug(job.title)}/${job.id}`}>
                  <div className={cx(classes.jobSection, "link-card")}>
                    {/* If the whole sidebar ISN'T for a fixed employer, each job should show the employer logo */}
                    {!org && <div className={cx(classes.logoContainer, classes.logoContainerPerJob)}
                                  style={{position: 'relative', height: '100px'}}>
                      <Image
                        width={200}
                        height={100}
                        style={{
                          objectFit: 'contain',
                        }}
                        src={job.organisation.logo_uri}
                        alt={`${job.organisation.name} logo`}
                      />
                    </div>}
                    <JobCard job={job}/>
                  </div>
                </Link>
              )) : (isLoading ? <Card
                className={cx(
                  classes.jobSection,
                  classes.jobCard,
                  classes.cardFooter,
                )}
              >Loading&hellip;</Card> : noJobs)}
            </Card>
          </Grid>
          {jobs.length > 0 && (
            <Grid item xs={12} alignItems={"center"} alignContent={"center"}>
              <Button
                style={{boxShadow: "none"}}
                className={cx(classes.primaryColor, classes.seeMoreBtn)}
                color="info"
                component={Link}
                href={`/jobs${org ? `?organisation=${org.id}` : ""}`}
                size="sm"
              >
                See all
              </Button>
            </Grid>
          )}
        </Grid>
      </div>
    </div>
  );
}
